<a
    class="flex w-full items-start ring-inset"
    [attr.tabindex]="tabindex()"
    [queryParams]="notification().queryParams"
    [routerLink]="routerLink()"
    (click)="notificationPanelService.openNotificationDetail(notification())"
>
    @if (firstAuthor(); as firstAuthor) {
        @if (hasMultipleAuthors()) {
            <div class="relative h-full w-40 shrink-0">
                <interacta-avatar [size]="'extra-small'" [user]="firstAuthor" />
                <interacta-avatar
                    class="absolute top-12 right-0"
                    [size]="'extra-small'"
                    [user]="authors()[1]"
                />
            </div>
        } @else {
            <interacta-avatar [user]="firstAuthor" />
        }
    }

    <div class="mr-12 ml-16 flex h-full min-w-0 grow flex-col">
        <div
            class="mb-4 line-clamp-3 text-left typo-sm text-ellipsis"
            [innerHTML]="text()"
            [ngClass]="read() ? 'text-text-mid-contrast' : 'text-text'"
        ></div>
        <div class="flex items-center gap-x-16 empty:hidden">
            @if (notification().timestamp; as timestamp) {
                <div
                    class="shrink-0 typo-xs-bold"
                    [matTooltip]="timestamp | dateTooltip"
                    [ngClass]="
                        read() ? 'text-text-mid-contrast' : 'text-text-primary'
                    "
                >
                    {{ timestamp | notificationDate }}
                </div>
            }
            @if (notification().community; as community) {
                <span
                    class="line-clamp-1 text-left typo-xs-bold-uppercase wrap-break-word"
                    [ngClass]="
                        read()
                            ? 'text-text-mid-contrast'
                            : 'text-text-low-contrast'
                    "
                >
                    {{ community.name | currentLanguage }}</span
                >
            }
        </div>
        @if (eventData(); as eventData) {
            @if (eventData.startAt; as startAt) {
                <div class="mt-8 flex gap-x-4">
                    <interacta-icon class="size-20" [icon]="'clock'" />
                    <div class="flex items-center typo-sm">
                        <interacta-zoned-date
                            [allDay]="eventData.allDay"
                            [date]="startAt"
                        />
                    </div>
                </div>
            }
        }
        <ng-content />
    </div>
</a>
